// extracted by mini-css-extract-plugin
export var btn = "InfoLector-module--btn--2gulv";
export var buttonWrapper = "InfoLector-module--buttonWrapper--pVtqF";
export var heading = "InfoLector-module--heading--v-09s";
export var infoWrapper = "InfoLector-module--infoWrapper--dWNI+";
export var lectorSection = "InfoLector-module--lectorSection--uD9IJ";
export var textWrapper = "InfoLector-module--textWrapper--3milC";